import { render, staticRenderFns } from "./concept1.vue?vue&type=template&id=528b6358&scoped=true&"
import script from "./concept1.vue?vue&type=script&lang=js&"
export * from "./concept1.vue?vue&type=script&lang=js&"
import style0 from "./concept1.vue?vue&type=style&index=0&id=528b6358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528b6358",
  null
  
)

export default component.exports